import styled from "styled-components"

interface ReportCard {
  bg?: string
  textColor?: string
}

export const ReportCard = styled.div`
  width: 95%;
  height: fit-container;
  background-color: ${(p: ReportCard) => p.bg};
  color: ${(p: ReportCard) => p.textColor};
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
  border: 0;
  padding: 0; 
  display: flex;
  flex-direction: column;
  align-items: center;
  Justify-items: center;
  font-family: MontserratRegular;
`

export const ReportCardContainer = styled.div`
  width: 95%;
  height: 220px;
  background-color: transparent;
  border-radius: 5px;
  border: 0;
  display: flex;
  flex-direction: column;
  justify-content: start;
  opacity: 1;
`

interface ReportCardColorBar {
  bgColor?: string
}

export const ReportCardColorBar = styled.div`
  width: 100%;
  height: 7px;
  background-color: ${(p: ReportCardColorBar) => p.bgColor};
  border-radius: 2px;
  border: 0;
  cursor: pointer;
`

export const ReportCardCounter = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  letter-spacing: 0.92px;
  flex-direction: row;
  align-items: end;
  justify-content: center;
  margin-bottom: 0;
  font-weight: 500;
  cursor: pointer;
`

export const ReportCardIcons = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: space-between;
  font-size: clamp(1.2rem, 2.5vw, 1.2rem);
  margin-bottom: 0;
  padding: 5px;
`

export const IconContainer = styled.div`
cursor: pointer;
`

export const Image = styled.img`
  width: 22px;
  height: 22px;
  border: none;
  margin: 2px 0 0 5px;
`

export const ReportCardImageContainer = styled.div`
  width: 100%;
  height: 120px;
  background-color: transparent;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

export const ReportCardImage = styled.img`
  width: 65%;
  max-height: 100%;
  object-fit: contain;
`

export const ReportCardName = styled.label`
  width: 100%; 
  text-align: center;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
`